import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CartItem from './CartItem'
import { CheckoutSection } from '../../components'
import { deleteItemAsync, updateItemQuantityAsync, updateItemQuantity } from './cartActionCreators'

const CartList = ({ items, onQuantityChange, onDelete }) => {
  const cartItems = items.map((item) => {
    return (
      <CartItem
        key={item.Id}
        item={item}
        onQuantityChange={onQuantityChange}
        onDelete={onDelete}
      />
    );
  });
  return (
    <CheckoutSection label={'Quote Details'} hideBodyBorder={true}>
        {cartItems}
    </CheckoutSection>
  );
}

CartList.propTypes = {
  items: PropTypes.array,
  onQuantityChange: PropTypes.func,
  onDelete: PropTypes.func
}

const cartListMapStateToProps = (state) => {
  return {
    items: state.entities.CartItems
  }
}

const cartListMapDispatchToProps = (dispatch, ownProps) => {
  return {
    onQuantityChange: (id, value) => {
      dispatch(updateItemQuantityAsync({id, qty: value, cartName: ownProps.cartName}));
    },
    onDelete: (id, prevQty) => {
      if ((typeof window !== 'undefined') && (typeof window.confirm !== 'undefined') && window.confirm("Delete this item?")) { 
        dispatch(deleteItemAsync({id, cartName: ownProps.cartName}))
      } else {
        dispatch(updateItemQuantity(id, prevQty || 1))
      }
    }
  }
}

const CartListContainer = connect(cartListMapStateToProps, cartListMapDispatchToProps)(CartList);

export default CartListContainer
